import jQuery from "jquery";
window.$ = window.jQuery = jQuery;

let Swiper = require('swiper/swiper-bundle.js');
window.Swiper = Swiper;

require("priority-plus");
